import { render, staticRenderFns } from "./NotificationInboxLeftSidebar.vue?vue&type=template&id=6960aa32&scoped=true"
import script from "./NotificationInboxLeftSidebar.vue?vue&type=script&lang=js"
export * from "./NotificationInboxLeftSidebar.vue?vue&type=script&lang=js"
import style0 from "./NotificationInboxLeftSidebar.vue?vue&type=style&index=0&id=6960aa32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6960aa32",
  null
  
)

export default component.exports